<template>
  <div :class="$parent.experiment.slug">
    <div class="screen-content" :class="'h-' + screen.hash">
      <div v-html="screen.html" @click="click($event)"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'screen',
  props: {
    screen: Object
  },
  data() {
    return {
      goNextAfterSend: true,
      skip: 0
    }
  },
  mounted() {
    this.goNextAfterSend = true
    this.skip = 0
    this.runBeforeScript()
  },
  updated() {
    this.goNextAfterSend = true
    this.skip = 0
    this.runBeforeScript()
  },
  methods: {
    click(e) {
      if (e.target.classList.contains('el-go')) {
        this.runAfterScript()
        this.$parent.go(this.skip)
      } else if (e.target.classList.contains('el-send')) {
        this.sendResult({
          'blocknum': this.screen.sectionNum,
          'trialnum': this.$parent.clickOrder,
          'blockcode': this.screen.sectionName,
          'trialcode': this.screen.name,
          'response': e.target.value,
          'statement': this.screen.statement,
          'object': this.screen.object
        })
        this.runAfterScript()
        if(this.goNextAfterSend) this.$parent.go(this.skip)
      }
    },
    sendResult(result) {
      let self = this
      var xhr = new XMLHttpRequest()
      var formData = new FormData()
      let latency = (+new Date() - self.$parent.screenTimeStart)

      var url = new URL(window.location.href.replace('/#', ''))
      var now = new Date();
      var date = '' + ('0' + now.getDate()).slice(-2) + ('0' + (now.getMonth()+1)).slice(-2) + now.getFullYear()
      var time = '' + ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2) + ':' + ('0' + now.getSeconds()).slice(-2)

      formData.append('experiment_id', self.$parent.experiment.id)
      formData.append('status', self.$parent.experiment.status)
      formData.append('session', localStorage.getItem('session'))
      formData.append('date', date)
      formData.append('time', time)
      formData.append('subject', btoa(url.search + '&_session=' + localStorage.getItem('session') + '&src=' + self.$parent.experiment.id))
      if(result.blocknum) formData.append('blocknum', result.blocknum)
      else formData.append('blocknum', this.screen.sectionNum)
      if(result.trialnum) formData.append('trialnum', result.trialnum)
      else formData.append('trialnum', this.$parent.clickOrder)
      if(result.blockcode) formData.append('blockcode', result.blockcode)
      else formData.append('blockcode', this.screen.sectionName)
      if(result.trialcode) formData.append('trialcode', result.trialcode)
      else formData.append('trialcode', this.screen.name)
      formData.append('response', result.response)
      if(result.statement) formData.append('statement', result.statement)
      if(result.object) formData.append('object', result.object)
      formData.append('latency', latency)
      formData.append('url', url.pathname + url.search)
      formData.append('ua', '-')
      var resultsToSave = {};
      formData.forEach((value, key) => {resultsToSave[key] = value})
      let results = [];
      if (localStorage.getItem('results')) results = JSON.parse(localStorage.getItem('results'))
      resultsToSave['name'] = formData.get('trialcode')
      resultsToSave['value'] = formData.get('response')
      results.push(resultsToSave)
      localStorage.setItem('results', JSON.stringify(results))
      xhr.open('POST', this.$root.apiUrl + 'v1/results/')
      // xhr.onload = function () {
      //   if (xhr.status === 201 ) {
      //     self.$parent.clickOrder++
      //   }
      // }
      xhr.send(formData)
      this.$parent.clickOrder++
    },
    wait() {
      this.goNextAfterSend = false
    },
    goTo(screen) {
      this.$parent.go(screen)
    },
    goNext() {
      this.$parent.go(this.skip)
    },
    skipScreens(count) {
      this.skip = count
    },
    getLoopIteration() {
      return (this.screen.loopIteration !== null && typeof this.screen.loopIteration !== 'undefined') ? this.screen.loopIteration + 1 : null
    },
    getScreens() {
      return this.$parent.screens
    },
    shuffle(arr) {
      return this.$parent.shuffle(arr)
    },
    getLoopIterationsCount() {
      if(this.screen.loop) {
        let A = this
        try {
          var loop = eval("(function() {" + A.screen.loop + "}())")
        } catch(e) {
          this.sendErrorLog(e, 'loop')
        }
        return (loop.iterations !== null && typeof loop.iterations !== 'undefined') ? loop.iterations : null
      } else return null
    },
    setScreenName(name) {
      this.screen.name = name
    },
    findResult(name) {
      var results = JSON.parse(localStorage.getItem('results'))
      if(!results) return false
      for(var i=0; i<results.length; i++) {
        if(results[i].name === name) return results[i].value
        if(results[i].trialcode === name) return results[i].response
      }
      return false
    },
    checkTargets(callback, trialcodes) {
      var xhr = new XMLHttpRequest()
      if(typeof trialcodes === 'string')
        xhr.open('GET', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/' + this.$parent.experiment.status + '/targets?trialcodes=' + trialcodes)
      else
        xhr.open('GET', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/' + this.$parent.experiment.status + '/targets')
      xhr.onload = () => {
        var response = JSON.parse(xhr.responseText)
        if (xhr.status === 200 && response.response) {
          if(typeof callback === 'function') callback(response.response)
        } else if (xhr.status === 404) {
          callback([])
        }
      }
      xhr.send()
    },
    setVar(name, value) {
      this.$parent.setVar(name, value)
    },
    getVar(name) {
      return this.$parent.getVar(name)
    },
    markAsEnded(callback) {
      var results = localStorage.getItem('results')
      var formData = new FormData()
      formData.append('results', results)
      var xhr = new XMLHttpRequest()
      xhr.open('POST', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/ended/' + localStorage.getItem('session'))
      xhr.onreadystatechange  = () => {
        if (xhr.status === 201) {
          if(typeof callback === 'function') callback(true)
        } else {
          if(typeof callback === 'function') callback(false)
        }
      }
      try {
        xhr.send(formData);
      } catch (error) {
        if(typeof callback === 'function') callback(false)
      }
    },
    markAsExcluded() {
      var xhr = new XMLHttpRequest()
      xhr.open('POST', this.$root.apiUrl + 'v1/results/' + this.$parent.experiment.id + '/excluded/' + localStorage.getItem('session'))
      xhr.send()
    },
    sendErrorLog(error, origin) {
      var url = new URL(window.location.href.replace('/#', ''))
      var xhr = new XMLHttpRequest()
      var formData = new FormData()
      var obj = {
        experiment_id: this.$parent.experiment.id,
        experiment_name: this.$parent.experiment.name,
        experiment_slug: this.$parent.experiment.slug,
        experiment_status: this.$parent.experiment.status,
        section_name: this.screen.sectionName,
        screen_name: this.screen.name,
        origin: origin,
        error: error,
        url: url.pathname + url.search,
        ua: '-'
      }
      Object.keys(obj).forEach(key => {
        formData.append(key, obj[key])
      })
      xhr.open('POST', this.$root.apiUrl + 'v1/felerjs/')
      xhr.send(formData)
    },
    setScreenStatement(statement) {
      this.screen.statement = statement
    },
    setScreenObject(object) {
      this.screen.object = object
    },
    runBeforeScript() {
      var toEval = 'var A = this;' + this.screen.scripts.before
      try {
        eval(toEval)
      }
      catch(e) {
        this.sendErrorLog(e, 'before script')
        console.error('Error in before script:')
        console.error(toEval)
        // if (e instanceof SyntaxError) {
          console.error(e.message)
        // } else {
          // throw(e)
        // }
      }
    },
    runAfterScript() {
      var toEval = 'var A = this;' + this.screen.scripts.after
      try {
        eval(toEval)
      }
      catch(e) {
        this.sendErrorLog(e, 'after script')
        console.error('Error in after script:')
        console.error(toEval)
        // if (e instanceof SyntaxError) {
          console.error(e.message)
        // } else {
          // throw(e)
        // }
      }
    }
  }
}
</script>
